import { ExplorerExtension } from './explorer';
import { ExplorerWorkspace } from './documents';

export class ToolsDocument {
  slug: string;
  source: string;
  name?: string;
  virtualSource?: string;
  documents?: ToolsDocument[];
  numberDocuments: number;
  converted?: string;
  convertedStatus: 'pending' | 'current' | 'complete' | 'fail';
  type?: ExplorerExtension; // type of converted file
  typeSource: ExplorerExtension; // type of the original file
  updatedAt?: Date;
  createdAt: Date;
  workspace: ExplorerWorkspace;
  size: number | null;
  favorite: boolean;

  constructor(doc?: ToolsDocument) {
    this.slug = doc?.slug;
    this.source = doc?.source;
    this.name = doc?.name;
    this.virtualSource = doc?.virtualSource;
    this.documents = (doc?.documents || []).map(d => new ToolsDocument(d));
    this.numberDocuments = doc?.numberDocuments;
    this.converted = doc?.converted;
    this.convertedStatus = doc?.convertedStatus;
    this.type = doc?.type;
    this.typeSource = doc?.typeSource;
    this.workspace = doc?.workspace;
    this.updatedAt = doc?.updatedAt ? new Date(doc.updatedAt) : null;
    this.createdAt = doc?.createdAt ? new Date(doc.createdAt) : null;
    this.size = doc?.size ? +(doc.size / 1048576).toFixed(2) : null;
    this.favorite = doc?.favorite ?? false;
  }
}

export const REGEX_FOLDER = /^((?![<>:"/\\|?*]).)*$/; // contains none of the following: <>:"/\\|?*
export const REGEX_FILE = /^([a-zA-Z0-9\s_.\-()])+$/;
